import ReplayRequest from '@/models/replayRequest';
import { AxiosError, AxiosResponse, AxiosStatic } from 'axios';
import { bus } from '@/main';

export default class ReplayRequestService {
  getReplayRequests(vueHttp: AxiosStatic, jobId: number): Promise<ReplayRequest[]> {
    return vueHttp
      .get<never>('replayrequest?jobId=' + jobId)
      .then((result: AxiosResponse<ReplayRequest[]>) => {
        const replayRequests = result.data;
        return replayRequests;
      })
      .catch((error: AxiosError) => {
        bus.$emit('alert', 'Get jobs failed ', 'error', 6000, error);
        return [] as ReplayRequest[];
      });
  }
}
